<template>
  <v-dialog v-model="dialogSendMap" width="500px" persistent fullscreen>
    <v-card>
      <v-card tile>
        <v-toolbar card style="background: #1a222c !important;">
          <v-toolbar-title class="white--text CSChatThai">
            <v-icon color="white">location_on</v-icon>&nbsp;&nbsp; {{$t('Dialog.map.header')}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon flat @click="closeDialogs">
            <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
      <v-card-text>
        <div style="background: white; padding-top: 2vh;">
          <v-layout justify-center align-center>
            <label>
              <v-layout row wrap>
                <v-flex xs8 sm8 md8>
                  <gmap-autocomplete
                    @place_changed="setPlace"
                    class="inputmap"
                    :placeholder ="$t('Dialog.map.placeholder')">
                  </gmap-autocomplete>
                </v-flex>
              <v-flex xs4 sm4 md4 style="margin-top: 2px; padding-left: 20px;">
                <button @click="SendMap" class="btnmap text-transform">{{$t('AnswerQuestion.send')}}</button>
              </v-flex>
            </v-layout>
            </label>
          </v-layout>
          <br>
          <gmap-map
            :center="center"
            :zoom="15"
            style="width:100%;  height: 400px;"
            @click="setPlaceandAdd"
          >
            <gmap-marker
              :key="index"
              v-for="(m, index) in markers"
              :position="center"
              :clickable="true"
              :draggable="true"
            ></gmap-marker>
          </gmap-map>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { sync } from 'vuex-pathify'
// import {gmapApi} from 'vue2-google-maps'
import google from 'vue2-google-maps'

export default {
  props: {dialogSendMap: false},
  data: () => ({
    map: '',
    x: 15,
    y: 30,
    lat: '',
    lng: '',
    center: { lat: 45.508, lng: -73.587 },
    markers: [],
    places: [],
    currentPlace: null,
    address: ''
  }),
  created () {
    // this.tokenuser = this.$cookie.get('tokenuser')
    // this.typeuser = localStorage.getItem('type_user')
    // this.axios.get('https://maps.googleapis.com/maps/api/place/details/json?key=AIzaSyA0hGnGEcqu2w2eN5XtNUJsNF2Ylv1Vl2g&placeid=ChIJ4ZnvKX274jARFsZN_d404sI').then((response) => {
    //   alert(response.data)
    // })
  },
  components: {
    google
  },
  mounted () {
    this.geolocate()
    // this.this.geolocate()()
  },
  watch: {
  },
  computed: {
    // google: gmapApi,
    ...sync('*')
  },
  methods: {
    closeDialogs () {
      // console.log('closeDialog')
      this.lat = ''
      this.lng = ''
      this.address = ''
      this.$emit('closeSendMap', false)
    },
    SendMap () {
      // console.log(this.lat, this.lng, this.address)
      this.$emit('send_location', this.lat, this.lng, this.address)
      this.closeDialogs()
    },
    setPlaceandAdd (place) {
      this.currentPlace = place
      this.addMarkerplace(this.currentPlace)
    },
    setPlace (place) {
      // console.log(place)
      this.currentPlace = place
      this.addMarker()
    },
    addMarker () {
      // console.log(this.currentPlace)
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        }
        this.lat = this.currentPlace.geometry.location.lat()
        this.lng = this.currentPlace.geometry.location.lng()
        this.address = this.currentPlace.name + ' ' + this.currentPlace.formatted_address
        this.markers.push({ position: marker })
        this.places.push(this.currentPlace)
        this.center = marker
        this.currentPlace = null
        // console.log(this.address)
      }
    },
    addMarkerplace (place) {
      // console.log(place)
      if (place) {
        const marker = {
          lat: place.latLng.lat(),
          lng: place.latLng.lng()
        }
        this.lat = place.latLng.lat()
        this.lng = place.latLng.lng()
        this.markers.push({ position: marker })
        this.places.push(place)
        this.center = marker
        this.currentPlace = null
      }
      // let self = this
      // var geocoder = new google.maps.Geocoder()
      // console.log(place.placeId)
      // geocoder.geocode({'placeId': 'ChIJyXhX4TYayUwRpj5vNT88SSU'}, function (results, status) {
      //   console.log(results, status)
      //   if (status === 'OK') {
      //     if (results[0]) {
      //       self.address = results[0].formatted_address
      //     }
      //   }
      // })
    },
    geolocate () {
      // console.log('geolocate')
      navigator.geolocation.getCurrentPosition(position => {
        const marker = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
        this.lat = position.coords.latitude
        this.lng = position.coords.longitude
        // let self = this
        // var geocoder = new google.maps.Geocoder()
        // var latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude)
        // console.log(latlng)
        // geocoder.geocode({'latLng': latlng}, function (results, status) {
        //   if (status === 'OK') {
        //     if (results[0]) {
        //       self.address = results[0].formatted_address
        //     }
        //   }
        // })
        this.markers.push({ position: marker })
        // console.log(this.address)
        this.center = marker
        this.currentPlace = null
      })
    }
    // displayLocationInfo (position) {
    //   console.log(position)
    // }
    // init () {
    //   this.map = new longdo.Map({
    //     placeholder: document.getElementById('map'),
    //     lastView: false
    //   })
    //   this.map.Ui.Keyboard.enable(true)
    //   var control3 = new longdo.TagPanel()
    //   this.map.Ui.add(control3)
    //   this.map.Ui.Crosshair.visible(false)
    //   this.map.Ui.LayerSelector.visible(false)
    // },
    // pin () {
    //   this.sendmap.Overlays.clear()
    //   var loc = this.sendmap.location(longdo.LocationMode.Pointer)
    //   // console.log(loc)
    //   this.showloc = loc
    //   var marker = new longdo.Marker(loc, {
    //     icon: {
    //       url: '/static/img/icons/pin.png',
    //       // html: '<em>icon</em>',
    //       offset: { x: this.x, y: this.y }
    //     },
    //     clickable: true,
    //     weight: longdo.OverlayWeight.Top
    //   })
    //   this.sendmap.Overlays.add(marker)
    // }
  }
}
</script>
<style type="text/css" scoped>
.text-transform {
  text-transform: none;
}
.btnmap {
  background-color: #0d52a8 !important;
  font-size: 16px !important;
  width: 70px !important;
  color: white !important;
  border-radius: 6px !important;
}
.inputmap {
  height: 30px !important;
  border-style: solid !important;
  padding-left: 10px !important;
  border-radius: 6px !important;
  width: 200px !important;
  border-width: thin !important;
  border-color: #b4b3b0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/dialog/MapDialogMobile.vue